import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  open: false,
  title: '',
  message: '',
  onAgreeAction: '',
  onDismissAction: '',
});

export const openAlert = createAction('OpenAlert');
export const closeAlert = createAction('CloseAlert');

const reducers = createReducer({
  [openAlert]: (state, { title, message, onAgreeAction, onDismissAction }) =>
    state.merge({ title, message, onAgreeAction, onDismissAction, open: true }),
  [closeAlert]: state => state.merge({ open: false }),
}, INITIAL_STATE);

export default reducers;
